import axios from 'axios';
import auth from './auth';


export default{  
    async getUserInfo(){
        var jwtToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
        const USERINFO_URL = 'https://'+auth.auth.getAppWebDomain() + '/oauth2/userInfo';
        var requestData = {
            headers: {
                'Authorization': 'Bearer '+ jwtToken
            }
        }
         return axios.get(USERINFO_URL, requestData).then(async response => {
            var userAdditionalInfo = [];
            response.data.user_additional_info = [];
            await axios.post(process.env.VUE_APP_LIFECHAIN_USERS_API_URI + "/items/" + response.data.username, JSON.stringify({}),requestData).then(userAdditionalInfoResponse => { 
                userAdditionalInfo = userAdditionalInfoResponse.data;            
            });
            response.data.user_additional_info = userAdditionalInfo;
            return response.data;
        });
    }
}